import { render, staticRenderFns } from "./ReportRetentions.vue?vue&type=template&id=85d6fbdc"
import script from "./ReportRetentions.vue?vue&type=script&lang=js"
export * from "./ReportRetentions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports